export default "__VITE_ASSET__MEf7LmpQ__"